export enum Feature {
    // REQUEST
  REQUEST_SHIPMENT               = 1,
  REQUEST_ISO_TANK_PROVIDER      = 2,
  REQUEST_DEPOT                  = 3,
  REQUEST_TRANSPORT              = 4,
  REQUEST_SURVEYOR               = 5,
  REQUEST_VESSEL                 = 6,

    // PHYSICAL_TRANSPORT
  JOURNEY_MANAGEMENT             = 7,
  SEARCH                         = 35,
  REPORT                         = 37,
  REPORT_MASTER                  = 40,

    // INTERMODAL
  ENTRY_LIST                     = 8,
  WEIGHBRIDGE_MANAGEMENT         = 9,
  TRANSFER_EIR_MANAGEMENT        = 10,
  TRANSFER_BOL_MANAGEMENT        = 11,
  CONTAINER_REHEATING_MANAGEMENT = 12,
  CONTAINER_CLEANING_MANAGEMENT  = 13,
  LOADING_MANAGEMENT             = 14,
  TRANSPORT_MANAGEMENT           = 24,
  LOAD_UNLOAD_MANAGEMENT         = 31,
  ONLOADING_MANAGEMENT           = 33,
  FLEET_MANAGEMENT               = 34,
  VESSEL_MANAGEMENT              = 39,
  CARGO_MANAGEMENT               = 41,
  DGD_MANAGEMENT                 = 42,

    // COMPLIANCE
  FLOW_MANAGEMENT                = 15,
  TEMPLATE_MANAGEMENT            = 16,
  DOCUMENT_MANAGEMENT            = 25,
  FLOW_VALIDATION                = 26,
  VERIFY_DOCUMENT                = 36,

    // ADMIN
  COMPANY_MANAGEMENT             = 17,
  USER_MANAGEMENT                = 18,
  ADMIN_TRADE_LANE_MANAGEMENT    = 30,
  PARTY_MANAGEMENT               = 38,
  CATEGORY_MANAGEMENT            = 43,

    // LOGCHAIN
  LOGCHAIN_COMPANY_MANAGEMENT    = 19,
  LOGCHAIN_USER_MANAGEMENT       = 20,
  ROLE_MANAGEMENT                = 21,
  TRADE_LANE_MANAGEMENT          = 22,
  LOGCHAIN_FLOW_MANAGEMENT       = 23,
  LOGCHAIN_REGULATORY_FILING     = 27,
  LOGCHAIN_REGULATORY_DASHBOARD  = 29,
  LICENCE_MANAGEMENT             = 44,

    // ALERT
  ALERT_VALIDATION               = 32,
}
